import * as ACTION_TYPES from '@actions/action_types'
export interface DownloadsStateType {
  id?: null | string
  download_id?: null | string
}
export const initialState = {
  id: null,
  download_id: null,
}
export const DownloadsReducer = (state: DownloadsStateType, action: A) => {
  switch (action.type) {
    case ACTION_TYPES.SHOW_DOWNLOAD:
      return { ...state, id: action.id }
    case ACTION_TYPES.CREATE_LINK_DOWNLOAD:
      return { ...state, download_id: action.id }
    default:
      return state
  }
}
export default DownloadsReducer
